import { render, staticRenderFns } from "./xfsUserAgreement.vue?vue&type=template&id=37a4ddee&scoped=true"
import script from "./xfsUserAgreement.vue?vue&type=script&lang=js"
export * from "./xfsUserAgreement.vue?vue&type=script&lang=js"
import style0 from "./xfsUserAgreement.vue?vue&type=style&index=0&id=37a4ddee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4ddee",
  null
  
)

export default component.exports